import { render, staticRenderFns } from "./VisitCardMessage.vue?vue&type=template&id=dab76438&scoped=true"
import script from "./VisitCardMessage.vue?vue&type=script&lang=js"
export * from "./VisitCardMessage.vue?vue&type=script&lang=js"
import style0 from "./VisitCardMessage.vue?vue&type=style&index=0&id=dab76438&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab76438",
  null
  
)

export default component.exports